import { TFlatBlock } from './blocksToFlatDocument';

export default function removeBlockChildren(flatBlocks: TFlatBlock[], blockId: string) {
  const blockResultIds: string[] = [];
  let index = flatBlocks.findIndex((b) => b.id === blockId);

  if (index < 0) {
    return flatBlocks.slice();
  }

  const oldDepth = flatBlocks[index].depth;
  index++;
  while (index < flatBlocks.length && flatBlocks[index].depth > oldDepth) {
    blockResultIds.push(flatBlocks[index].id);
    index++;
  }
  return flatBlocks.filter((b) => !blockResultIds.includes(b.id));
}
